import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { firebaseApp } from './firebaseConfig';

const authInstance = getAuth(firebaseApp);

/**
 * Point at a local Auth emulator when `VITE_AUTH_EMULATOR_URL` is set, so sign-in can be exercised
 * end to end without a real account. Guarded on `DEV` as well as the variable: a production build
 * has `import.meta.env.DEV` folded to `false`, so this branch and the import are dropped from the
 * bundle and no deployed artifact can be pointed at an emulator by setting an environment variable.
 */
if (import.meta.env.DEV && import.meta.env.VITE_AUTH_EMULATOR_URL) {
    connectAuthEmulator(authInstance, import.meta.env.VITE_AUTH_EMULATOR_URL, {
        disableWarnings: true,
    });
}

const getIdToken = () => {
    // Didn't have this warning on our other app
    // and I don't want to run this twice every time we do this
    // maybe there's a way to verify that there is a current user without the internet delay?
    return authInstance.currentUser
        ?.getIdToken(/* forceRefresh */ true)
        .catch((e) => console.error(`error getting firebase token: ${JSON.stringify(e)}`));
};

const auth = () => authInstance;

export { auth, getIdToken };
